module.exports = __webpack_public_path__ + "static/media/goblin_chief_club.556efd22.png";